import arrow from "./arrow.svg";
import arrows from "./arrows.svg";
import backArrow from "./backArrow.svg";
import upArrow from "./upArrow.svg";
import forwardArrow from "./forwardArrow.svg";
import bell from "./bell.svg";
import home from "./home.svg";
import coin from "./coin.svg";
import loading from "./loading.svg";
import logout from "./logout.svg";
import menu from "./menu.svg";
import polygon from "./polygon.svg";
import settings from "./settings.svg";
import instagram from "./instagram.svg";
import website from "./website.svg";
import help from "./help.svg";
import checkmark from "./checkmark.svg";
import deleteIcon from "./deleteIcon.svg";
import shoppingCart from "./shoppingCart.svg";
import file from "./file.svg";
import legal from "./legal.svg";
import info from "./info.svg";
import linkedin from "./linkedin.svg";
import facebook from "./facebook.svg";
import refresh from "./refresh.svg";
import vimeo from "./vimeo.svg";
import incidents from "./incidents.svg";
import faq from "./faq.svg";

// coin logos
import elementsCoin from "./coins/elementsCoin.svg";
import elevatorCoin from "./coins/elevatorCoin.svg";
import resolutaCoin from "./coins/resolutaCoin.svg";
import $odaCoin from "./coins/$odaCoin.svg";
import webmilesCoin from "./coins/webmilesCoin.svg";
import godoCoin from "./coins/godoCoin.svg";
import makerlabCoin from "./coins/makerlabCoin.svg";
import milkshekelCoin from "./coins/milkshekelCoin.svg";
import korrencyCoin from "./coins/korrencyCoin.svg";
import nounCoin from "./coins/nounCoin.svg";
import sxmCoin from "./coins/sxmCoin.svg";
import sxminfraCoin from "./coins/sxminfraCoin.svg";
import techCoin from "./coins/techCoin.svg";
import touchCoin from "./coins/touchCoin.svg";
import duppieCoin from "./coins/duppieCoin.svg";
import bigshotsCoin from "./coins/bigshotsCoin.svg";
import deductionCoin from "./coins/deductionCoin.svg";
import stutitCoin from "./coins/stutitCoin.svg";
import defaultCoin from "./coins/defaultCoin.svg";

// board Members
import evanGelders from "./people/evanGelders.svg";
import jasperOlieroock from "./people/jasperOlieroock.svg";
import maikeVile from "./people/maikeVile.svg";

const icons = {
  arrow,
  arrows,
  backArrow,
  upArrow,
  bell,
  coin,
  checkmark,
  deleteIcon,
  facebook,
  faq,
  file,
  forwardArrow,
  incidents,
  linkedin,
  loading,
  logout,
  home,
  help,
  info,
  menu,
  polygon,
  settings,
  instagram,
  website,
  shoppingCart,
  elementsCoin,
  elevatorCoin,
  resolutaCoin,
  $odaCoin,
  webmilesCoin,
  godoCoin,
  makerlabCoin,
  milkshekelCoin,
  korrencyCoin,
  nounCoin,
  sxmCoin,
  sxminfraCoin,
  techCoin,
  touchCoin,
  duppieCoin,
  bigshotsCoin,
  deductionCoin,
  stutitCoin,
  defaultCoin,
  evanGelders,
  jasperOlieroock,
  maikeVile,
  legal,
  refresh,
  vimeo,
};

export default icons;
